<template>
  <div
    :class="['page-header', 'row no-gutters', 'px-md-4', overview || 'pt-md-5']"
  >
    <div
      class="mx-4 mx-lg-0 py-4 py-md-0 col-12 col-md-12 col-sm-4 text-sm-left mb-md-0"
    >
      <span class="text-uppercase page-subtitle">{{ topHeader }}</span>
      <h3 class="page-title pt-md-1">{{ headerText }}</h3>
    </div>
  </div>
</template>
<script>
export default {
  props: ['topHeader', 'headerText', 'overview'],
};
</script>
